<!--
  TODO : 버튼 공통 모듈
-->
<template>
  <q-tooltip :content-class="contentClass" :content-style="contentStyle">
    <!-- {{contents}} -->
    <q-list>
      <q-item>
        <q-item-section>
          <q-item-label class="text-black">{{title}}</q-item-label>
          <q-item-label caption lines="2">{{contents['ibm_title'].text}}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </q-tooltip>
</template>

<script>
export default {
  /* attributes: name, components, props, data */
  name: 'c-assess-tooltip',
  props: {
    name: {
      type: String,
      default: '',
    },
    ibmTooltip: {
      type: String,
      default: '',
    },
    ibmClassCd: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: 'bg-blue-grey-2',
    },
    contentStyle: {
      type: String,
      default: 'font-size: 16px;min-width:500px !important;max-width:500px !important',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    contentsItems() {
      return [
        '제목',
        '조치부서',
        '조치완료 요청일',
        '조치일',
      ]
    },
    contents() {
      let _contents = {};
      if (this.ibmTooltip) {
        let spliteItems = this.$_.split(this.ibmTooltip, '|');
        let idx = 0;
        this.$_.forEach(spliteItems, spliteItem => {
          let _item = this.$_.split(spliteItem, ':')
          this.$set(_contents, _item[0], {
            text: _item[1],
            label: this.contentsItems[idx]
          })
          idx++;
        })
      }
      return _contents;
    },
    title() {
      let text = '';
      if (this.contents) {
        if (!this.ibmClassCd || this.ibmClassCd === 'IC00000001') {
          // 개선
          text += `[개선] ${this.contents['action_dept_name'].text} / ${this.contents['action_complete_request_date'].text}`
        } else if (this.ibmClassCd === 'IC00000005') {
          // 즉시조치
          text += `[즉시] ${this.contents['action_dept_name'].text} / ${this.contents['action_complete_date'].text}`
        }
      }
      return text;
    }
  },
  /* Vue lifecycle: created, mounted, destroyed, etc */
  mounted() {
  },
  /* methods */
  methods: {
  },
};
</script>

